import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import CookieBanner from "../CookieBanner/CookieBanner";

const Layout = ({ children }) => {
  return (
    // pb-16: chừa chỗ cho thanh điều hướng cố định dưới đáy (mobile).
    // overflow-x-clip: chặn mọi phần tử tràn ngang làm iOS Safari thu nhỏ trang / lắc ngang khi lướt.
    // Dùng clip (không phải hidden) để không tạo vùng cuộn riêng → header sticky vẫn hoạt động.
    <div className="flex min-h-screen flex-col overflow-x-clip pb-16 lg:pb-0">
      <Header />
      <main id="main" className="flex-1">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Layout;
